export const carriers = {
  displayName: {
    allstate: 'Allstate',
    alpha: 'Alpha Insurance',
    aviva: 'Aviva Canada',
    avivaElite: 'Aviva Elite',
    avivaTraders: 'Aviva Traders',
    bcaa: 'BCAA Insurance',
    belair: 'Belair Direct ',
    beneva: 'Beneva',
    caa: 'CAA Insurance',
    chieftain: 'Chieftain Insurance',
    chubb: 'Chubb',
    coachman: 'Coachman',
    cooperators: 'Co-Operators',
    cumis: 'Cumis Insurance',
    desjardins: 'Desjardins',
    dumfries: 'Dumfries Mutual',
    echelon: 'Echelon',
    economical: 'Economical Insurance',
    facility: 'Facility Association',
    federation: 'Federation',
    goreMutual: 'Gore Mutual',
    guarantee: 'Guarantee Company',
    ia: 'Industrial Alliance Financial Group',
    intact: 'Intact Insurance',
    intergroupe: 'Integroupe Insurance',
    jevco: 'Jevco',
    laCapitale: 'La Capitale',
    laPersonnelle: 'La Personnelle',
    ledor: 'LEDOR Insurance',
    lloyds: "Lloyd's",
    missiquoi: 'Missisquoi',
    nationalBankIns: 'National Bank',
    northbridge: 'Northbridge',
    optium: 'Optimum',
    other: 'Other',
    pafco: 'Pafco',
    peelMutual: 'Peel Mutual',
    pembridge: 'Pembridge',
    perth: 'Perth Insurance',
    portage: 'Portage Mutual',
    promutuel: 'Promutuel Insurance',
    rbc: 'RBC',
    rsa: 'RSA',
    sonnet: 'Sonnet',
    squareOne: 'Square One',
    ssq: 'SSQ Insurance',
    stateFarm: 'State Farm',
    td: 'TD Insurance',
    travelers: 'Travelers Canada',
    unica: 'Unica',
    unique: "L'Unique General Insurance",
    wawanesa: 'Wawanesa',
    western: 'Western',
  },
  mobileAppTracking: {
    intact: 'Intact - My drive',
    travelers: 'Travelers - IntelliDrive',
  },
};

export type CarriersTranslations = typeof carriers;
